import { withLocalState } from 'pyradux';

import TradeDetailsContainer from './TradeDetails.container';
import reducer from './TradeDetails.reducer';

const withLocalStateOptions = {
  reducer,
  stateKey: 'tradeDetails',
  sagas: [],
};

export default withLocalState(withLocalStateOptions, TradeDetailsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/index.js